import { render, staticRenderFns } from "./taskform.vue?vue&type=template&id=791404c0&scoped=true&"
import script from "./taskform.vue?vue&type=script&lang=js&"
export * from "./taskform.vue?vue&type=script&lang=js&"
import style0 from "./taskform.vue?vue&type=style&index=0&id=791404c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791404c0",
  null
  
)

export default component.exports